// TODO: Remove this once all pages are migrated to react
// Or if all ExternalAuth variable usage is removed

angular.module('bb.external').factory('ExternalAuth', ExternalAuth);

ExternalAuth.$inject = ['$rootScope'];
function ExternalAuth($rootScope) {
  const vm = this;
  if ($rootScope.reactExternalAuth) vm.auth = $rootScope.reactExternalAuth;
  return vm;
}

export {};
